import { useCallback } from 'react';

/**
 * Keyboard navigation for an ARIA tablist using automatic activation.
 */
const useTablistKeyboard = ({
  tabIds,
  activeId,
  onSelect,
  buildId = (id) => id,
  orientation = 'horizontal',
}) => useCallback((event) => {
  if (!tabIds?.length) return;

  const currentIndex = tabIds.indexOf(activeId);
  const nextKey = orientation === 'vertical' ? 'ArrowDown' : 'ArrowRight';
  const previousKey = orientation === 'vertical' ? 'ArrowUp' : 'ArrowLeft';
  let nextIndex;

  if (event.key === nextKey) {
    nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % tabIds.length;
  } else if (event.key === previousKey) {
    nextIndex = currentIndex <= 0 ? tabIds.length - 1 : currentIndex - 1;
  } else if (event.key === 'Home') {
    nextIndex = 0;
  } else if (event.key === 'End') {
    nextIndex = tabIds.length - 1;
  } else {
    return;
  }

  event.preventDefault();
  const nextId = tabIds[nextIndex];
  onSelect(nextId);

  if (typeof document !== 'undefined') {
    const focusSelectedTab = () => document.getElementById(buildId(nextId))?.focus();
    focusSelectedTab();
    queueMicrotask(focusSelectedTab);
  }
}, [activeId, buildId, onSelect, orientation, tabIds]);

export default useTablistKeyboard;
